<template>
  <div :class="[className]">
    <div class="form-group row">
      <div class="col-md-12">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['className'],
}
</script>



// WEBPACK FOOTER //
// src/components/base/Col.vue